module.exports = __webpack_public_path__ + "media/images/28february-644bef6ab24cfcf83e3a1255b5b52d17.jpg";